import React from "react";

export default function InspectionCycleBreadcrumbs({ items, onNavigate }) {
  return (
    <nav className="inspection-cycle-flow-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => (
          <React.Fragment key={`${item.label}-${index}`}>
            <li>
              {item.to ? (
                <button
                  type="button"
                  onClick={() => onNavigate(item.to, item.state)}
                >
                  {item.label}
                </button>
              ) : (
                <span
                  aria-current={index === items.length - 1 ? "page" : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
            {index < items.length - 1 && (
              <li
                className="inspection-cycle-flow-breadcrumbs__separator"
                aria-hidden="true"
              >
                <i className="bx bx-chevron-right" />
              </li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
